var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNobooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cinema (1) 1",
    clipPath: "url(#clip0_5411_15430)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M56.6625 80H61.15L62.3218 51.875H55.4906L56.6625 80Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M74.0734 37.8984C72.8703 35.7625 70.875 34.1812 68.5063 33.5078C66.3266 30.3562 62.7391 28.4375 58.9062 28.4375C55.0734 28.4375 51.4859 30.3562 49.3062 33.5078C46.9375 34.1812 44.9422 35.7625 43.7391 37.8984C40.3844 38.4313 37.8125 41.3422 37.8125 44.8438V47.1875H80V44.8438C80 41.3422 77.4281 38.4313 74.0734 37.8984Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M65.8423 80H74.9548L79.6423 51.875H67.0142L65.8423 80Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M38.1703 51.875L42.8578 80H51.9703L50.7984 51.875H38.1703Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M51.6766 7.03125L48.161 0H37.7766L41.2922 7.03125H51.6766Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M65.6251 11.7188H56.9172L53.4016 18.75H65.6251V11.7188Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M65.6251 7.03125V0H53.4016L56.9172 7.03125H65.6251Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M51.6766 11.7188H41.2922L37.7766 18.75H48.161L51.6766 11.7188Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M36.0516 11.7188H25.6672L22.1516 18.75H32.536L36.0516 11.7188Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M21.5984 9.375L16.9109 0H0V18.75H16.9109L21.5984 9.375ZM12.5 11.7188H7.8125V7.03125H12.5V11.7188Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M36.0516 7.03125L32.536 0H22.1516L25.6672 7.03125H36.0516Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M40.8297 33.8344C42.3016 31.9453 44.2234 30.4781 46.4391 29.5531C49.5406 25.8937 54.0922 23.75 58.9062 23.75C61.2531 23.75 63.5406 24.2594 65.625 25.2078V23.4375C49.6467 23.4375 14.7014 23.4375 0 23.4375V60.9375H34.9297L33.125 50.1125V44.8438C33.125 39.9172 36.2141 35.5219 40.8297 33.8344ZM28.125 51.5625H9.375V46.875H28.125V51.5625ZM28.125 42.1875H9.375V37.5H28.125V42.1875Z",
    fill: "#D3D3D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5411_15430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNobooking);
export default __webpack_public_path__ + "static/media/nobooking.2bcde68c49637f7a084b4f6dd8f7aace.svg";
export { ForwardRef as ReactComponent };